import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { Add as Plus, CardGiftcard as Gift } from '@mui/icons-material';

interface ActionBarProps {
  publishedCount: number;
  inProgressCount: number;
  unusedCount: number;
  availableCredits: number;
  onCreateLGCYClick: () => void
}

export const ActionBar: FC<ActionBarProps> = ({
  publishedCount,
  inProgressCount,
  unusedCount,
  availableCredits,
  onCreateLGCYClick,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        alignItems: { xs: 'flex-start', lg: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        p: 2,
        bgcolor: 'white',
        borderRadius: '24px',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        border: '1px solid rgb(254, 238, 237)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1.5,
          width: { xs: '100%', lg: 'auto' },
        }}
      >
        <Button
          component={Link}
          to="/tributes/create/details"
          variant="contained"
          startIcon={<Plus sx={{ width: 16, height: 16 }} />}
          sx={{
            width: { xs: '100%', sm: 'auto' },
            height: '44px',
            bgcolor: 'rgb(242, 110, 99)',
            '&:hover': {
              bgcolor: 'rgb(220, 95, 85)',
            },
            color: 'white',
            minHeight: '44px',
            textTransform: 'none',
            borderRadius: '12px',
          }}
          onClick={onCreateLGCYClick}
        >
          Create LGCY
        </Button>

        <Button
          component={Link}
          to="/gift/create"
          variant="outlined"
          startIcon={<Gift sx={{ width: 16, height: 16 }} />}
          sx={{
            width: { xs: '100%', sm: 'auto' },
            height: '44px',
            borderColor: 'rgb(156, 39, 176)',
            color: 'rgb(156, 39, 176)',
            '&:hover': {
              bgcolor: 'rgba(156, 39, 176, 0.05)',
              borderColor: 'rgb(156, 39, 176)',
            },
            minHeight: '44px',
            textTransform: 'none',
            borderRadius: '12px',
          }}
        >
          Gift a LGCY
        </Button>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          fontSize: '0.875rem',
          color: 'rgba(0, 0, 0, 0.6)',
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              bgcolor: 'rgb(242, 110, 99)',
              borderRadius: '50%',
            }}
          />
          {publishedCount} Published
        </Box>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              bgcolor: 'rgb(255, 160, 0)',
              borderRadius: '50%',
            }}
          />
          {inProgressCount} In Progress
        </Box>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              bgcolor: 'rgba(158, 158, 158)',
              borderRadius: '50%',
            }}
          />
          {unusedCount} Unused
        </Box>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              bgcolor: 'rgb(156, 39, 176)',
              borderRadius: '50%',
            }}
          />
          {availableCredits} {availableCredits === 1 ? 'Credit' : 'Credits'}
        </Box>
      </Box>
    </Box>
  );
};

export default ActionBar;
